import React from 'react';

export default function ButtonComponent(props){
  return <button onClick={props.onClick} className={`btn border-0 btn-light rounded-pill text-uppercase fw-bold`} 
      style={{color:"white",width:"100%",height:"50px",backgroundColor:'var(--vc-lightblue)'}} >
    {props.label}
  </button>
}